<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <b-form-select v-model="search.compare_type" :options="compare_type">
                    </b-form-select>
                    &nbsp;
                    <date-picker v-model="search.date"
                                 :lang="lang"
                                 range
                                 format="DD/MM/YYYY"
                                 v-if="search.compare_type == 1"
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด" confirm>
                    </date-picker> &nbsp;
                    <date-picker range :lang="lang" type="month"
                                 format="MM/YYYY"
                                 v-model="search.month"
                                 v-if="search.compare_type == 2"
                                 placeholder="เดือนเริ่มต้น - เดือนสิ้นสุด" confirm>
                    </date-picker>
                    <date-picker v-model="search.year"
                                 :lang="lang"
                                 range
                                 type="year"
                                 format="YYYY"
                                 v-if="search.compare_type == 3"
                                 placeholder="ปีเริ่มต้น - ปีสิ้นสุด" confirm>
                    </date-picker> &nbsp;
                    <button type="button" class="btn btn-success" @click="searchReportCompareProduct">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th width="250px">รหัสสินค้า</th>
                    <template v-for="(report,key,i) in report_compare_product">
                        <template v-for="(data,key ,j) in report">
                            <th width="120px" v-if="i == 1">
                                <template v-if="!search.compare_type || search.compare_type == 1">
                                    {{ key | moment("DD/MM/YYYY") }}
                                </template>
                                <template v-else>{{ key }}</template>
                            </th>
                        </template>
                    </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="(report,key,index) in report_compare_product">
                    <tr>
                        <td>{{ key }}</td>
                        <template v-for="(data,key,index) in report">
                            <td>
                                <!--{{Object.keys(data).length}}-->
                                <template v-if="Object.keys(data).length > 0">
                                    <template v-for="info in data">
                                        <span v-if="info">
                                            {{ info.product_real | amount }}
                                        </span>
                                    </template>
                                </template>
                                <template v-else>0</template>
                            </td>
                        </template>
                    </tr>
                </template>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate" @paginate="getPage">
            </vue-pagination>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
                </loading>
            </b-modal>
        </div>
        <!--<pre class="alert-success">{{report_compare_product}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";

export default {
    components: {Loading, VuePagination, Multiselect, DatePicker},
    name: "dashboard-report-date-product",
    data() {
        return {
            msg: '',
            status_loading: '',
            event_submit: "",
            page: 1,
            report_compare_product: [],
            search: {
                compare_type: "",
                date: [],
                month: [],
                year: []
            },
            compare_type: [
                {value: "", text: "เลือกช่วงค้นหา"},
                {value: 1, text: "รายวัน"},
                {value: 2, text: "รายเดือน"},
                {value: 3, text: "รายปี"}
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormatMonth: {
                stringify: (date) => {
                    return date ? moment(date).add(543, 'y').format('MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormatYear: {
                stringify: (date) => {
                    return date ? moment(date).add(543, 'y').format('YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        }
    },
    created() {
        this.getReportCompareProduct();
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getReportCompareProduct() {
            let data = {
                compare_type: "",
                start: "",
                end: "",
            };
            this.$store.dispatch("Dashboard/getReportCompareProduct", {
                page: this.page,
                data: data
            }).then(res => {
                this.report_compare_product = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        searchReportCompareProduct() {
            if (this.search.compare_type == 1 && this.search.date.length < 1) {
                alert("กรุณาเลือกช่วงวัน")
            } else if (this.search.compare_type == 2 && this.search.month.length < 1) {
                alert("กรุณาเลือกช่วงเดือน")
            } else if (this.search.compare_type == 3 && this.search.year.length < 1) {
                alert("กรุณาเลือกช่วงปี")
            } else {
                this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                this.status_loading = 1;
                this.showLoadingModal();
                this.event_submit = true;
                let start = "";
                let end = "";
                if (this.search.date.length > 0) { //date
                    if (this.search.date[0] && this.search.date[0]) {
                        start = moment(this.search.date[0]).format("YYYY-MM-DD");
                        end = moment(this.search.date[1]).format("YYYY-MM-DD");
                    } else {
                        this.search.date = [];
                    }
                }
                if (this.search.month.length > 0) { //month
                    if (this.search.month[0] && this.search.month[0]) {
                        start = moment(this.search.month[0]).format("YYYY-MM-DD");
                        end = moment(this.search.month[1]).format("YYYY-MM-DD");
                    } else {
                        this.search.month = [];
                    }
                }
                if (this.search.year.length > 0) { //year
                    if (this.search.year[0] && this.search.year[0]) {
                        start = moment(this.search.year[0]).format("YYYY-MM-DD");
                        end = moment(this.search.year[1]).format("YYYY-MM-DD");
                    } else {
                        this.search.year = [];
                    }
                }
                let data = {
                    compare_type: this.search.compare_type,
                    start: start,
                    end: end,
                };
                //console.log(data);
                this.$store.dispatch("Dashboard/getReportCompareProduct", {
                    page: this.page,
                    data: data
                }).then(res => {
                    this.report_compare_product = res.data
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                    this.hideLoadingModal()
                }).catch(() => {
                    this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                    this.showLoadingModal();
                });
            }
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchReportCompareProduct();
            } else {
                this.getReportCompareProduct();
            }
        },
    },

}
</script>

<style scoped>

</style>
